import _ from "lodash";
import { apiClient, occmClient } from 'utils/clients';
import externals from "utils/externals";

export function base64EncodeAuthData(authData) {
    if (!authData) {
        return window.btoa(JSON.stringify(authData));
    }
    const userMetadataFieldName = 'http://cloud.netapp.com/user_metadata';
    let authUserMetadataName = authData[userMetadataFieldName]?.name;
    const clonedAuthData = _.cloneDeep(authData);

    //encodeURIComponent is used to encode the string, so that it can be safely 
    // passed to btoa function
    //wrapping in ifs, as for federation some name fields may not be present
    if (authUserMetadataName) {
        clonedAuthData[userMetadataFieldName].name = encodeURIComponent(authUserMetadataName);
    }
    if (authData.name) {
        _.set(clonedAuthData, "name", encodeURIComponent(authData.name));
    }
    if (authData.nickname) {
        _.set(clonedAuthData, "nickname", encodeURIComponent(authData.nickname));
    }

    return window.btoa(JSON.stringify(clonedAuthData));
}

export function logUserActions(action, userId) {
    if (action && userId) {
        const tenancyURL = process.env.REACT_APP_IS_AIDP === "true" ? process.env.REACT_APP_AIDE_TENANCY_API_URL : externals.tenancyV4Backend
        const client = process.env.REACT_APP_IS_AIDP === "true" ? occmClient : apiClient;
        client.patch(`${tenancyURL}/users/${userId}`, {
            "type": "application/vnd.netapp.bxp.user",
            "version": "1.0",
            "stateDesired": action
        });
    }
}